{
  "general": {
    "article": "Colorway",
    "articles": "Colorways",
    "model": "Style",
    "models": "Styles",
    "segmentation": "Assortment",
    "segmentations": "Assortments"
  }
}
